import { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../config/firebase';
import { useAuth } from '../contexts/AuthContext';
import { TeamMember } from '../services/team.service';
export function useTeamMemberships() {
  const { currentUser } = useAuth();
  const [state, setState] = useState<{ uid: string; members: TeamMember[]; loading: boolean }>({
    uid: '',
    members: [],
    loading: true,
  });
  useEffect(() => {
    if (!currentUser || currentUser.isAnonymous) {
      setState({ uid: currentUser?.uid || '', members: [], loading: false });
      return;
    }
    const uid = currentUser.uid;
    setState({ uid, members: [], loading: true });
    const timeout = window.setTimeout(() => setState({ uid, members: [], loading: false }), 8000);
    const unsubscribe = onSnapshot(
      query(collection(db, 'teamMemberships'), where('userId', '==', uid)),
      { includeMetadataChanges: true },
      snapshot => {
        if (snapshot.metadata.fromCache) {
          setState(previous =>
            previous.loading ? previous : { uid, members: [], loading: false }
          );
          return;
        }
        window.clearTimeout(timeout);
        setState({
          uid,
          members: snapshot.docs
            .map(d => ({ id: d.id, ...d.data() }) as TeamMember)
            .filter(m => m.status === 'active'),
          loading: false,
        });
      },
      () => {
        window.clearTimeout(timeout);
        setState({ uid, members: [], loading: false });
      }
    );
    return () => {
      window.clearTimeout(timeout);
      unsubscribe();
    }; // Fail closed on denied/offline subscriptions.
  }, [currentUser?.uid, currentUser?.isAnonymous]);
  const matching = state.uid === (currentUser?.uid || '');
  return { members: matching ? state.members : [], loading: matching ? state.loading : true };
}
